import React, { Suspense, useMemo } from "react";
import { useContext, useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "../../i18n";
import { useTranslation } from "react-i18next";
import { Alert, Skeleton, Table, Tag } from "antd";
import { ConfigContext } from "../../hooks/context/config";
import { Typography } from "antd";
import RemunerationForm from "./remunerationForm/remunerationForm";
import RemunerationInfo from "./remunerationInfo/remunerationInfo";
import "./remuneration.sass";
import RemunerationResult from "./remunerationResult/remunerationResult";
import { useConfig, useGetFirstRewardRetribution, useGetReferralRewardRetribution } from "src/api/api";
import RemunerationSummary, { TagsInfo } from "./remunerationSummary/remunerationSummary";
import { RestApiClientContext } from "src/hooks/context/pageContext";
import { useGetAcademyRetribution } from "src/api/api";
import { UserContext } from "src/hooks/context/userInfo";
import { FormattedNumber } from "react-intl";

const { Paragraph, Title } = Typography;
export interface BadgesReward {
  name: string,
  amount: Amount
  minNumOfBadges: number
  badgesToComplete: BadgesToComplete[]
}

export interface Amount {
  idAcademyGroups: string
  idCurrency: string
  amount: number
  amountType: string
}
export interface BadgesToComplete {
  id: string
  name: string
  selected: boolean
  isEarned: boolean
}
type BadgeStatus = "0" | "1" | "2" | "3" | "4";
export interface BadgeFromMoodleAcademy {
  id: number;
  name: string;
  description: string;
  type: number;
  status: BadgeStatus;
}
// Componente principal de remuneraciones
const Remuneration = () => {
  const restApiClient = useContext(RestApiClientContext);
  const { t } = useTranslation(["remuneration"]);
  const infoClient = useContext(ConfigContext);
  const user = useContext(UserContext);

  const [statusReferral, setStatusReferral] = useState<boolean>(false);
  const [badgesRewards, setBadgesRewards] = useState<BadgesReward[]>([]);
  const [firstReward, setFirstReward] = useState(null);
  const [referrals, setReferrals] = useState([]);
  const [selectForm, setSelectForm] = useState(null);

  // Position del scroll en el top de la pagina
  var scrollLib = require("react-scroll");
  var scroll = scrollLib.animateScroll;
  const getAcademyRetribution = useGetAcademyRetribution()
  const getFirstReward = useGetFirstRewardRetribution();
  const getReferralsRetribution = useGetReferralRewardRetribution()
  // Recoge los elementos para la gráfica
  const result = useConfig(selectForm?.id);

  const [noIndexNoFollow, setNoIndexNoFollow] = React.useState(false);
  const getNoIndexNoFollow = (): void => {
    restApiClient.getNoIndexNoFollowConfig().then(v => {
      setNoIndexNoFollow(v);
    });

  }
  const columnsAcademy = [
    {
      title: t("summary.group"),
      dataIndex: "name",
      key: "name"
    },
    {
      title: t("summary.channels"),
      dataIndex: "channels",
      key: "channels",
      render: (a: any, b: any) => {
        return a.length > 0 ? <TagsInfo list={a.map(x => x.name)} /> : '-';
      }

    },
    {
      title: t("summary.badgesToComplete"),
      dataIndex: "badgesToComplete",
      key: "badgesToComplete",
      render: (a: any, b: any) => {
        return a.length > 0 ? <TagsInfo list={a.map(x => x.name)} /> : '-';
      }

    },

    {
      title: t("summary.minNumOfBadges"),
      dataIndex: "minNumOfBadges",
      key: "minNumOfBadges",
      render: (a) => {
        return a >= 0 ? a : 0;
      }
    },
    {
      title: t("summary.quantities"),
      dataIndex: "amount",
      key: "amount",
      render: (a: any) => {
        return a.amountType === 'fixed' ? <FormattedNumber
          value={a.amount}
          style="currency"
          currency={a.idCurrency}
        /> : `${a.amount} %`
      }
    },
    {
      title: t("summary.isEarned"),
      dataIndex: "isEarned",
      key: "isEarned",
      render: (a: any, b: any) => {
        return <Tag color={a ? 'green' : 'yellow'}>
          {a ? t("summary.won") : t("summary.no-won")}
        </Tag>;
      }

    },
  ];
  const referralsColumns = [
    {
      title: t("summary.validations"),
      dataIndex: "validations",
      key: "validations",
      render: (a: any, b: any) => {
        return t("summary.from-to", { from: b.from, to: b.to || "∞" });
      }
    },
    {
      title: t("summary.quantities"),
      dataIndex: "amount",
      key: "amount",
      render: (a: any, b: any) => {
        return <span>
       { t("summary.recive") + " "} 
       {b?.amountType === 'fixed' ? <FormattedNumber
          value={a}
          style="currency"
          currency={b?.idCurrency}
        /> : `${a} %` }

        {" "+ t("summary.per-referral") }
        </span>  ;
      }

    }
  ];
  const currencyActual = useMemo(() => firstReward?.firstRewardList?.find(x => x.idCurrency === user.GetCurrency() || firstReward?.firstRewardList[0]), [firstReward]);

  const [selectedConfigId, setSelectecConfigId] = useState<string>('');

  const referralFiltered = referrals.filter(x => x.type == "REFERRER" && x.idCurrency === user.GetCurrency());
  useEffect(() => {
    setSelectecConfigId(selectForm?.id);
  }, [selectForm])

  useEffect(() => {
    getNoIndexNoFollow();
    scroll.scrollToTop();
    getAcademyRetribution().then((res) => {
      setBadgesRewards(res.data || []);
    })
    getFirstReward().then((res) => {
      if (res.data) {
        setFirstReward(res.data)
      }
    })
    getReferralsRetribution().then((res) => {
      setReferrals(res.data)
    })
    restApiClient.getStatusReferral().then((response) => {
      setStatusReferral(response)
    })

  }, []);
  return (
    <>
      <Helmet>
        <title>
          {infoClient.incentiveSiteName} {t("seo:title.register", { 0: infoClient.incentiveSiteName })} |{" "}
          {t("seo:title.register")}
        </title>
        <meta name="description" content={t("seo:description.register", { 0: infoClient.incentiveSiteName })} />
        {
          noIndexNoFollow ?
            <meta name="robots" content="noindex, nofollow" />
            : <meta name="robots" content="index,follow" />
        }
        <link rel="canonical" href={infoClient.urlWA + t("urls.public.register")} />
        <link rel="icon" type="image/ico" href={infoClient.favicon} sizes="32x32" />
        <link href={infoClient.urlWA + t("urls.public.register")} hrefLang="es-ES" rel="alternate" />
      </Helmet>

      <div className="col-12 mt-3 rew-container">
        <Title className="col-12" level={4}>
          {t("remuneration:title")}
        </Title>
        <Paragraph className="col-12">{t("remuneration:paragraph", { 0: infoClient.description })}</Paragraph>
      </div>
      <div className="row col-12 display-data-form-info mt-3">
        <div className="col-12 col-lg-7 order-12 order-lg-1 padding-form-remuneration">
          <RemunerationForm setSelectForm={setSelectForm} />
        </div>
        <div className="col-12 col-lg-5 order-1 order-lg-12 mb-3">
          <RemunerationInfo />
        </div>
      </div>
      <div className="col-12 mt-3">
        {
          result?.periods.length > 0 && <RemunerationResult result={result} />
        }
      </div>
      {firstReward && firstReward?.status && !firstReward?.isFirstBookingValidated && <div id="first-reward-info" className="col-12 mt-3">
        <div className="summary-remuneration">
          <Title className="mt-4" level={4}>
            {t("first-reward-title")}
          </Title>
          <div>
            <Paragraph>{t("first-reward-subtitle", {
              increment: currencyActual?.amount || currencyActual?.amount || 0,
              currency: currencyActual?.amountType === "percent" ? "%" : (currencyActual?.idCurrency || "")
            })}
            </Paragraph>

          </div>
        </div>
      </div>}

      {badgesRewards.length > 0 &&
        <div className="col-12 mt-3">
          <div className="summary-remuneration">
            <Title className="mt-4" level={4}>
              {t("academy-title")}
            </Title>
            <Table id="table-remuneration-academy" columns={columnsAcademy} dataSource={badgesRewards} pagination={false} />
          </div>
        </div>
      }
      {referrals.length > 0 && statusReferral &&
        <div className="col-12 mt-3">
          <div className="summary-remuneration">
            <Title className="mt-4" level={4}>
              {t("summary.referrals-title")}
            </Title>
            <Table id="table-remuneration-referrals" columns={referralsColumns} pagination={false} dataSource={referralFiltered} />
              {referralFiltered[referralFiltered.length-1]?.to?<Alert type="warning" message={<span>{t("summary.referrals-warning")} 
               {<strong>{t("summary.referrals-warning-strong", { number: (referralFiltered[referralFiltered.length-1]?.to || 0)+1})}</strong>}
                </span>} showIcon  />: null}
          </div>

        </div>
      }


      <div className="col-12 mt-3">
        <RemunerationSummary selectedConfigId={selectedConfigId} />
      </div>

    </>
  );
};

const RemunerationWrapper = () => (
  <Suspense fallback={<Skeleton />}>
    <Remuneration />
  </Suspense>
);
export default RemunerationWrapper;
